import { render, staticRenderFns } from "./WhoSelect.vue?vue&type=template&id=3829ab48"
import script from "./WhoSelect.vue?vue&type=script&lang=ts"
export * from "./WhoSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports